module.exports = __webpack_public_path__ + "img/pause-fill.70a06771.svg";